import React, { useState, useMemo, useEffect } from 'react'
import Navigation from '../../Components/Navigation'
import TableOrdenDeDespacho from '../../Components/TableOrdenDeDespacho'
import { Row, Col, Container } from 'react-bootstrap'
import { Truck } from 'react-bootstrap-icons'
import './OrdenDeDespacho.css'
import { useDispatch, useSelector } from 'react-redux'
import { format } from 'date-fns'
import { t } from 'i18next'
import {
  FormatedDate,
  generateColorStatus,
  valitadorODCPDF,
} from 'Utils/functions'
import { useParams } from 'react-router-dom'
import { searchSalesDocumentDetail } from 'redux/actions/cotizacionActions'
import {
  closeStatusDocument,
  docHeaderStatusDescription,
  documentTypeId,
  fulfillmentPlans,
  pendingStatusDocument,
  processStatusDocument,
  fullfilmentIds,
  getTrackingRestrictedCompanyIds,
} from 'Utils/constants'
import MiniLoading from 'Components/MiniLoading'
import RelationalDocLabel from 'Components/RelationalDocLabel'
import { useBusLogic } from './hooks/useBusLogic'
import OrderTrackingModal from 'Components/OrderTrackingModal/OrderTrackingModal'
import DeliveryDateLabel from 'Components/DeliveryDateLabel/DeliveryDateLabel'
import { CustomTooltip } from 'Components/CustomToolTip'
import Tints from 'Hooks/useTintsController/Tints'
import { getProductDisplayText } from 'Utils/getProductDisplayText'

function OrdenDeDespacho(props) {
  const dispatch = useDispatch()
  const [comment, setComment] = useState('')
  const [loadingData, setLoadingData] = useState(false)
  const [showTrackingModal, setShowTrackingModal] = useState(false)
  const [dataODC, setDataODC] = useState(false)
  const param = useParams()
  const { currentSelectedAddress, isWebDocument } = useBusLogic()

  const companyId = useSelector(state => state.company.CompanyId)

  const useSelectorProducts = useSelector(
    state => state.sellOrder.sellOrderObject
  )

  const orderDispatchPostData = useSelector(
    state => state.sellOrder.orderDispatchPostData?.Data
  )

  const [formatSelectedDate, setFormatSelectedDate] = useState('')
  const colorsStatus = {
    process: '#81E7CB',
    pending: '#FF96A0',
    close: '#FFDF94',
  }

  // Determinar si la orden de despacho debe mostrar el botón de tracking
  const shouldFetchSettings = useMemo(() => {
    return (
      orderDispatchPostData?.SalesDocumentInfo?.FulfillmentPlanId ===
      fullfilmentIds.homeDelivery.fulfillmentPlanId
    )
  }, [orderDispatchPostData])

  // IDs de compañías que tienen restricción de tracking
  const TRACKING_RESTRICTED_COMPANY_IDS = getTrackingRestrictedCompanyIds()

  // Verificar si la compañía actual tiene acceso al tracking
  const hasTrackingAccess = useMemo(
    () => !TRACKING_RESTRICTED_COMPANY_IDS.includes(companyId),
    [companyId]
  )

  const shouldShowTrackingButton = hasTrackingAccess && shouldFetchSettings

  useEffect(() => {
    setComment(orderDispatchPostData?.SalesDocumentInfo?.Comments)
  }, [orderDispatchPostData])

  const hasHomeDelivery = useMemo(
    () =>
      orderDispatchPostData?.SalesDocumentInfo?.Lines?.some(line =>
        fulfillmentPlans.homeDelivery.some(
          plan => plan.fulfillmentPlanId === line.FulfillmentPlanId
        )
      ),
    [orderDispatchPostData]
  )

  const setTableData = data => {
    if (!data) return []
    const products = data.Lines?.map((product, index) => {
      return {
        referencia: product?.SystemCode,
        descripción: (
          <>
            <span>{getProductDisplayText(product).replace('\n', ' - ')}</span>
            {product?.ColorVariants && !product?.IsExtendedWarranty && (
              <Tints key={product?.ProductId} tints={product?.ColorVariants} />
            )}
          </>
        ),
        pendiente: product?.sellOrderTableValues?.pendiente,
        cantidad: product?.Quantity,
        precio_unitario: product?.Price || 0,
        Descuento: product?.DiscountAmount,
        precio_total: product?.Amount,
        solicitud_despacho: product?.Quantity,
        pending_date: formatSelectedDate,
        send_address: isWebDocument
          ? currentSelectedAddress?.Name ||
            orderDispatchPostData?.SalesDocumentInfo?.Address_AddressDetail
          : orderDispatchPostData?.SalesDocumentInfo?.Address_AddressDetail,
      }
    })
    return products
  }

  const productsData = useMemo(
    () => setTableData(orderDispatchPostData?.SalesDocumentInfo),
    [orderDispatchPostData, formatSelectedDate, currentSelectedAddress]
  )

  const columns = useMemo(
    () => [
      {
        Header: t('DISPATCH_ORDER_T.REFERENCE_HEADER'),
        accessor: t('DISPATCH_ORDER_T.REFERENCE_ACCESOR'),
        width: '10%',
        arrowOrderEnabled: true,
      },
      {
        Header: t('DISPATCH_ORDER_T.DESCRIPTION_LABEL'),
        accessor: t('DISPATCH_ORDER_T.DESCRIPTION_ACCESOR'),
        width: '50%',
        arrowOrderEnabled: true,
      },
      {
        Header: t('DISPATCH_ORDER_T.DISPATCH_QTY'),
        align: 'center',
        accessor: t('DISPATCH_ORDER_T.DISPATCH_QTY_ACCESOR'),
        width: '10%',
      },
      {
        Header: t('DISPATCH_ORDER_T.UNITY_PRICE_HEADER'),
        accessor: t('DISPATCH_ORDER_T.UNITY_PRICE_ACCESOR'),
        width: '5%',
        arrowOrderEnabled: true,
      },
      {
        Header: t('DISPATCH_ORDER_T.PRECIO_TOTAL_HEADER'),
        accessor: t('DISPATCH_ORDER_T.PRECIO_TOTAL_ACCESOR'),
        width: '5%',
        arrowOrderEnabled: true,
      },
      {
        Header: t('DISPATCH_ORDER_T.ORDER_DATE_HEADER'),
        accessor: t('DISPATCH_ORDER_T.ORDER_DATE_ACCESOR'),
        width: '10%',
      },
      {
        Header: t('DISPATCH_ORDER_T.DELIVERY_DIRECTION'),
        accessor: t('DISPATCH_ORDER_T.DELIVERY_DIRECTION_ACCESOR'),
        width: '15%',
      },
    ],
    []
  )

  const fetchDocument = async (
    DocumentTypeId = null,
    id = null,
    header = null
  ) => {
    setLoadingData(true)
    try {
      const payload = {
        DocumentTypeId,
        DocumentHeaderId: id,
        DocumentNumber: header,
        PageNumber: 1,
        PageSize: 1,
      }
      const data = await dispatch(searchSalesDocumentDetail(payload))
      if (data && data.Status.Code === 200) {
        if (DocumentTypeId.toLowerCase() === documentTypeId.SD.toLowerCase()) {
          const dataFormated = {
            Data: {
              SalesDocumentInfo: {
                ...data.Data,
              },
            },
          }
          dispatch({
            type: 'DISPATCH_ORDER_POST_RESULT',
            payload: dataFormated,
          })
          setFormatSelectedDate(
            format(
              new Date(dataFormated.Data.SalesDocumentInfo.DeliveryDate),
              'dd/MM/yyyy'
            )
          )
          // get index on RelationDoc array when RelationDoc.DocumentTypeId is equal to DocumentTypeId.Quotation
          const index = data.Data?.RelationDoc?.findIndex(
            item =>
              item.DocumentTypeId.toLowerCase() ===
              documentTypeId.QUOTATION.toLowerCase()
          )
          const { DocHeaderId, DocumentNumber, DocumentTypeId } =
            data.Data?.RelationDoc?.[index]
          await fetchDocument(DocumentTypeId, DocHeaderId, DocumentNumber)

          const hasODC = data?.Data?.RelationDoc.find(
            doc => doc.DocumentTypeId === documentTypeId.ODC
          )
          const ODV = data.Data?.RelationDoc?.find(
            doc =>
              doc?.DocumentNumber.includes('ODV') ||
              doc?.DocumentTypeId?.toLowerCase().includes(
                documentTypeId?.ODV?.toLowerCase()
              )
          )
          if (hasODC) {
            const response = await valitadorODCPDF(ODV)
            setDataODC(response)
          }
        }
        if (
          DocumentTypeId.toLowerCase() ===
          documentTypeId.QUOTATION.toLowerCase()
        ) {
          dispatch({
            type: 'SET_SELL_ORDER_OBJECT',
            payload: data.Data,
          })
          setLoadingData(false)
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  const isDocumentCanceledOrClosed =
    orderDispatchPostData?.SalesDocumentInfo?.DescriptionStatus ===
      docHeaderStatusDescription.canceled ||
    orderDispatchPostData?.SalesDocumentInfo?.DescriptionStatus ===
      docHeaderStatusDescription.closed ||
    orderDispatchPostData?.SalesDocumentInfo?.DescriptionStatus ===
      closeStatusDocument.fullPicking

  useMemo(() => {
    if (param?.id) {
      fetchDocument(documentTypeId.SD, param?.id)
    }
  }, [])

  const getInvoiceDocumentNumber = () => {
    const relatedDocs = orderDispatchPostData?.SalesDocumentInfo?.RelationDoc
    const invoiceDoc = relatedDocs?.find(
      doc => doc.DocumentTypeId === documentTypeId.INVOICE
    )
    return invoiceDoc?.DocumentNumber || null
  }

  return (
    <>
      <OrderTrackingModal
        open={showTrackingModal}
        onClose={() => setShowTrackingModal(false)}
        companyID={orderDispatchPostData?.SalesDocumentInfo?.CompanyId}
        invoiceNumber={getInvoiceDocumentNumber()}
        data-testid="modal-order-tracking"
      />
      <Navigation />
      {loadingData ? (
        <MiniLoading
          full={true}
          noMargin={true}
          data-testid="container-loading"
        />
      ) : (
        <div
          className="sell-order-generada-container"
          data-testid="container-dispatch-order">
          <div className="sell-order-generada">
            <div
              className="sell-order-editar-header"
              data-testid="container-dispatch-order-header">
              <h2
                className="titulo-sell-order"
                data-testid="text-dispatch-order-title">
                {t('DISPATCH_ORDER_T.DISPATCH_TITLE')}
              </h2>
              {shouldShowTrackingButton && (
                <div
                  className="order-tracking-container"
                  data-testid="container-order-tracking">
                  <CustomTooltip
                    placement="bottom-end"
                    title={
                      <p style={{ fontSize: 12 }}>Trazabilidad de pedidos</p>
                    }>
                    <button
                      className="order-tracking-btn"
                      onClick={() => setShowTrackingModal(true)}
                      data-testid="btn-open-order-tracking">
                      <div className="left">
                        <p>nuevo</p>
                      </div>
                      <div className="right">
                        <Truck className="order-tracking-icon" />
                        {t('DISPATCH_ORDER_T.ORDER_TRACKING')}
                      </div>
                    </button>
                  </CustomTooltip>
                </div>
              )}
            </div>
            <div
              className="dispatch-order-info-gen"
              data-testid="container-dispatch-order-info">
              <div
                className="dispatch-order-info-gen-cliente"
                data-testid="container-customer-info">
                <p
                  className="dispatch-order-info-gen-text"
                  data-testid="text-order-number">
                  Orden N°:{' '}
                  {orderDispatchPostData?.SalesDocumentInfo.DocumentNumber}
                </p>
                <p
                  className="dispatch-order-info-gen-text"
                  data-testid="text-customer-name">
                  {`Cliente: ${useSelectorProducts?.CustomerNameDocument}`}
                </p>
                <p
                  className="dispatch-order-info-gen-text"
                  data-testid="text-customer-email">
                  {t('DISPATCH_ORDER_T.EMAIL_LABEL', {
                    email:
                      useSelectorProducts?.CustomerEmail ||
                      useSelectorProducts?.EmailAddress ||
                      useSelectorProducts?.CustomerEmail ||
                      t('DISPATCH_ORDER_T.NO_INFO_LABEL'),
                  })}
                </p>
                <p
                  className="dispatch-order-info-gen-text"
                  data-testid="text-customer-phone">
                  {t('DISPATCH_ORDER_T.PHONE_LABEL', {
                    phone:
                      useSelectorProducts?.Cellphone_Number ||
                      useSelectorProducts?.Telephone_Number ||
                      t('DISPATCH_ORDER_T.NO_INFO_LABEL'),
                  })}
                </p>
                <p
                  className="sell-order-info-gen-text"
                  data-testid="text-credit-account">
                  {t('CREDIT_ACCOUNT', {
                    account:
                      orderDispatchPostData?.SalesDocumentInfo
                        ?.CreditAccountNumber ||
                      t('SELL_ORDER_T.NO_INFO_LABEL'),
                  })}
                </p>
                <DeliveryDateLabel
                  date={orderDispatchPostData?.SalesDocumentInfo?.DeliveryDate}
                  variant="pickup"
                  data-testid="text-pickup-date"
                />
              </div>
              <div
                className="dispatch-order-info-gen-retiro"
                data-testid="container-delivery-info">
                {hasHomeDelivery ? (
                  <>
                    <p
                      className="dispatch-order-info-gen-text"
                      data-testid="text-delivery-type-home">
                      {t('DISPATCH_ORDER_T.DELIVERY_HOME')}
                    </p>
                    <p
                      className="dispatch-order-info-gen-text"
                      data-testid="text-delivery-address">
                      {t('DISPATCH_ORDER_T.ADDRESS_LABEL', {
                        address:
                          orderDispatchPostData?.SalesDocumentInfo
                            ?.Address_Street ||
                          useSelectorProducts?.QuoteAddressDetail,
                      })}
                    </p>
                    <p
                      className="dispatch-order-info-gen-text"
                      data-testid="text-customer-address">
                      {
                        orderDispatchPostData?.SalesDocumentInfo
                          ?.CustomerAddress
                      }
                    </p>
                    <p
                      className="dispatch-order-info-gen-text"
                      data-testid="text-address-alias">{`Alias: ${
                      isWebDocument
                        ? currentSelectedAddress?.Name ||
                          orderDispatchPostData?.SalesDocumentInfo
                            ?.Address_AddressDetail
                        : orderDispatchPostData?.SalesDocumentInfo
                            ?.Address_AddressName ||
                          orderDispatchPostData?.SalesDocumentInfo
                            ?.Address_AddressDetail
                    }`}</p>
                    <DeliveryDateLabel
                      date={
                        orderDispatchPostData?.SalesDocumentInfo?.DeliveryDate
                      }
                      variant="delivery"
                      data-testid="text-delivery-date"
                    />
                  </>
                ) : (
                  <>
                    <p
                      className="dispatch-order-info-gen-text"
                      data-testid="text-branch-pickup">
                      {t('DISPATCH_ORDER_T.BRANCH_RECOLECTION_LABEL')}
                    </p>
                    <p
                      className="dispatch-order-info-gen-text"
                      data-testid="text-warehouse-address">
                      {t('DISPATCH_ORDER_T.ADDRESS_LABEL', {
                        address:
                          orderDispatchPostData?.SalesDocumentInfo
                            ?.WarehouseAddress,
                      })}
                    </p>
                    <p
                      className="dispatch-order-info-gen-text"
                      data-testid="text-warehouse-description">
                      {
                        orderDispatchPostData?.SalesDocumentInfo
                          ?.WarehouseDescription
                      }
                    </p>
                  </>
                )}
                <p
                  className="dispatch-order-info-gen-text"
                  data-testid="text-dispatch-type">
                  {t('DISPATCH_ORDER_T.DISPATCH_TYPE', {
                    dispatch_type:
                      orderDispatchPostData?.SalesDocumentInfo
                        ?.FulfillmentPlanDescription,
                  })}
                </p>
                {orderDispatchPostData?.SalesDocumentInfo
                  ?.BranchPickupContact && (
                  <>
                    <p
                      className="dispatch-order-info-gen-text"
                      data-testid="text-pickup-contact-name">
                      {t('DISPATCH_ORDER_T.MERCHANDISE.RETIREMENT', {
                        retirement:
                          orderDispatchPostData?.SalesDocumentInfo
                            ?.BranchPickupContact?.FullName ||
                          t('DISPATCH_ORDER_T.NO_INFO_LABEL'),
                      })}
                    </p>
                    <p
                      className="dispatch-order-info-gen-text"
                      data-testid="text-pickup-contact-phone">
                      {t('DISPATCH_ORDER_T.MERCHANDISE.PHONE', {
                        phone:
                          orderDispatchPostData?.SalesDocumentInfo
                            ?.BranchPickupContact?.PhoneNumber ||
                          t('DISPATCH_ORDER_T.NO_INFO_LABEL'),
                      })}
                    </p>
                    <p
                      className="dispatch-order-info-gen-text"
                      data-testid="text-pickup-contact-note">
                      {t('DISPATCH_ORDER_T.MERCHANDISE.NOTE', {
                        note:
                          orderDispatchPostData?.SalesDocumentInfo
                            ?.BranchPickupContact?.AdditionalNote ||
                          t('DISPATCH_ORDER_T.NO_INFO_LABEL'),
                      })}
                    </p>
                  </>
                )}
              </div>
              <div
                className="dispatch-order-info-gen-vendedor"
                data-testid="container-sales-info">
                <p
                  className="dispatch-order-info-gen-text"
                  data-testid="text-sales-agent-name">
                  {useSelectorProducts?.SalesAgentFullName}
                </p>
                <p
                  className="dispatch-order-info-gen-text"
                  data-testid="text-creation-date">
                  Fecha:{' '}
                  {FormatedDate(
                    orderDispatchPostData?.SalesDocumentInfo?.CreatedDate
                  )}
                </p>
                <p
                  className="dispatch-order-info-gen-text"
                  data-testid="text-quotation-number">
                  {t('DISPATCH_ORDER_T.QUOTATION_LABEL', {
                    quotation: useSelectorProducts?.DocumentNumber,
                  })}
                </p>
                <p
                  className="dispatch-order-info-gen-text"
                  data-testid="text-sales-channel">
                  {t('DISPATCH_ORDER_T.CHANNEL_USED_LABEL', {
                    channel_used: useSelectorProducts?.Channel || '',
                  })}
                </p>
                {orderDispatchPostData?.SalesDocumentInfo
                  ?.DescriptionStatus && (
                  <p
                    className="status"
                    data-testid="text-order-status"
                    style={{
                      backgroundColor: generateColorStatus(
                        orderDispatchPostData?.SalesDocumentInfo
                          ?.DescriptionStatus,
                        pendingStatusDocument,
                        processStatusDocument,
                        closeStatusDocument,
                        null,
                        colorsStatus
                      ),
                    }}>
                    {
                      orderDispatchPostData?.SalesDocumentInfo
                        ?.DescriptionStatus
                    }
                  </p>
                )}
              </div>
            </div>
            {orderDispatchPostData?.SalesDocumentInfo.LogTypeError && (
              <p className="despacho-nota" data-testid="text-error-message">
                {orderDispatchPostData.SalesDocumentInfo.LogTypeError.toLowerCase() ===
                'oracle'
                  ? t('DISPATCH_ORDER_T.MESSAGE_ALERT_ERROR.ORACLE')
                  : orderDispatchPostData.SalesDocumentInfo.LogTypeError.toLowerCase() ===
                    'savetransactionv2'
                  ? t('DISPATCH_ORDER_T.MESSAGE_ALERT_ERROR.SAVETRANSACTION')
                  : null}
              </p>
            )}

            <TableOrdenDeDespacho
              data={productsData}
              columns={columns}
              hideFooter={true}
              isProductPage={false}
              isInventory={false}
              data-testid="table-dispatch-order-products"
            />
            {useSelectorProducts?.DocumentDueDate ? (
              <div
                className="date-time-updated mt-5"
                data-testid="container-modification-info">
                <p data-testid="text-modified-by">
                  Modificado por:{' '}
                  {orderDispatchPostData?.SalesDocumentInfo?.CreatedByName ||
                    'Desconocido'}
                </p>
                <p data-testid="text-modification-date">
                  Fecha de última modificación:{' '}
                  {FormatedDate(
                    orderDispatchPostData?.SalesDocumentInfo?.CreatedDate
                  )}
                </p>
              </div>
            ) : null}
          </div>

          <Container
            className="footer-container"
            data-testid="container-footer">
            <Row className="footer-info">
              <Col data-testid="container-related-documents">
                <Row
                  className="footer-left-text-title"
                  data-testid="text-related-docs-title">
                  {t('DISPATCH_ORDER_T.RELATED_DOCS')}
                </Row>
                {orderDispatchPostData?.SalesDocumentInfo?.RelationDoc?.map(
                  (item, index) => {
                    return (
                      <Row
                        className="footer-left-text"
                        key={index}
                        data-testid={`container-related-doc-${index}`}>
                        <RelationalDocLabel
                          dataODC={dataODC}
                          value={item}
                          document={orderDispatchPostData?.SalesDocumentInfo}
                          data-testid={`text-related-doc-${index}`}
                        />
                      </Row>
                    )
                  }
                )}
              </Col>
              <Col data-testid="container-comments">
                <Row
                  className="footer-right-text-title"
                  data-testid="text-comments-title">
                  {t('DISPATCH_ORDER_T.COMMENT')}
                </Row>

                <Row className="footer-right-row-container">
                  <textarea
                    className="footer-textarea-style"
                    value={comment || ''}
                    disabled={isDocumentCanceledOrClosed}
                    onChange={e => setComment(e.target.value)}
                    data-testid="input-comments-textarea"
                  />
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  )
}

export default OrdenDeDespacho
